import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setSuccess } from '../../redux/flashMessages'

export const SuccessNotification = ({message}) => {
  const dispatch = useDispatch()
  useEffect(()=>{
    const timeout = setTimeout(()=>dispatch(setSuccess()),5000);
    return ()=>{
      clearTimeout(timeout)
    }
  },[message])
  return (
    <div style={{position:'absolute',top:'10px',opacity:'0.9'}}>
    <div className='alert alert-success d-flex align-items-center justify-content-between'>
      {message}
      <button className='btn btn-success btn-sm' onClick={()=>dispatch(setSuccess())}>
        <i className='fa fa-times'></i>
      </button>
    </div>
    </div>
  )
}
